import React from "react";

import "./style.scss";
import FilterCard from "./FilterCard";

const GisMapDetail = ({ closeSurveyedDetail, mapEl }) => {
  return (
    <div className="data-table-detail">
      <div>
        {/* User/Address/Filter */}
        <FilterCard mapEl={mapEl} closeSurveyedDetail={closeSurveyedDetail} />
      </div>
    </div>
  );
};

export default GisMapDetail;
